import * as routesUtils from '../utils/RoutesUtils'
import { API } from '../core/app.routes'
import httpClient from '../core/httpClient'
import commonService from './common.service'

const pdfService = () => {
  const common = commonService()
	// GET pdf/invoice/:id, resolving to { url, job } once the worker has written the PDF.
	const fetchInvoicePDF = (params = {}) => {
		let path = routesUtils.getApiPath(API.PDF_INVOICE, { recordId: params.recordId })
		// Dual invoicing: append withoutDiscount query param if specified
		const queryParams = []
		const offset = new Date().getTimezoneOffset() * -1 // Convert to minutes east of UTC (moment format)
		queryParams.push(`offset=${offset}`)
		if (params.hasDisclosure) queryParams.push('hasDisclosure=true')
		if (params.lang) queryParams.push(`lang=${params.lang}`)
		if (params.withoutDiscount) queryParams.push('withoutDiscount=true')
		if (queryParams.length) path += `?${queryParams.join('&')}`

		return httpClient.get(path)
	}
	const fetchEstimatePDF = (params = {}) => {
		let path = routesUtils.getApiPath(API.PDF_ESTIMATE, { recordId: params.recordId })
		// Pass the browser's timezone offset so the PDF shows the correct scheduled time
		const queryParams = []
		const offset = new Date().getTimezoneOffset() * -1 // Convert to minutes east of UTC (moment format)
		queryParams.push(`offset=${offset}`)
		if (params.hasDisclosure) queryParams.push('hasDisclosure=true')
		if (params.lang) queryParams.push(`lang=${params.lang}`)
		if (queryParams.length) path += `?${queryParams.join('&')}`
		return httpClient.get(path)
	}
	const fetchWorkorderPDF = (params = {}) => {
		let path = routesUtils.getApiPath(API.PDF_WORKORDER, { recordId: params.recordId })
		const offset = new Date().getTimezoneOffset() * -1
		path += `?offset=${offset}`
		return httpClient.get(path)
	}
	return {
		invoicePDF: async (params = {}, targetBlank = true) => {
			// Generate filename based on version
			const suffix = params.withoutDiscount ? '_no_discount' : ''
			return fetchInvoicePDF(params)
				.then((res) => {
          common.downloadLink(`invoice_${params.recordId}${suffix}.pdf`, res.url, targetBlank)
          return res
				})
		},
		// US-40351 — the URL of the calibration certificate for one vehicle of the invoice (the
		// per-vehicle attachment tile), for useOpenCertificate to open in a new tab through
		// utils/openSignedUrl. Same synchronous-poll contract as invoicePDF ({ url, job }); the API
		// answers 409 { reason } when that vehicle is no longer eligible. vehicleId is invoice.vehicles[i]._id.
		invoiceCertificateUrl: (params = {}) => {
			let path = routesUtils.getApiPath(API.INVOICE_CERTIFICATE, { invoiceId: params.invoiceId })
			const queryParams = []
			const offset = new Date().getTimezoneOffset() * -1 // minutes east of UTC (moment format)
			queryParams.push(`offset=${offset}`)
			if (params.vehicleId) queryParams.push(`vehicleId=${encodeURIComponent(params.vehicleId)}`)
			path += `?${queryParams.join('&')}`
			return httpClient.get(path).then(res => res && res.url)
		},
		// The URL alone, for a caller that opens it itself in a new tab (see utils/openSignedUrl).
		invoicePDFUrl: (params = {}) => fetchInvoicePDF(params).then(res => res && res.url),
		estimatePDFUrl: (params = {}) => fetchEstimatePDF(params).then(res => res && res.url),
		workorderPDFUrl: (params = {}) => fetchWorkorderPDF(params).then(res => res && res.url),
		// Legacy invoiceADASPDF removed - F-30833
		// invoiceADASPDF: async (params = {}, targetBlank = true) => {
		// 	const path = routesUtils.getApiPath(API.PDF_INVOICE_ADAS, params)
		// 	return httpClient.get(path)
		// 		.then((res) => {
		// 			common.downloadLink(`invoice_${params.recordId}.pdf`, res.url, targetBlank)
		// 			return res
		// 		})
		// },
		estimatePDF: async (params = {}, targetBlank = true) => {
			return fetchEstimatePDF(params)
				.then((res) => {
          common.downloadLink(`estimate_${params.recordId}.pdf`, res.url, targetBlank)
          return res
				})
		},
		estimateSupplementPDF: async (params = {}, targetBlank = true) => {
			let path = routesUtils.getApiPath(API.PDF_ESTIMATE_SUPPLEMENT, { recordId: params.recordId })
			const offset = new Date().getTimezoneOffset() * -1
			path += `?offset=${offset}`
			return httpClient.get(path)
				.then((res) => {
          common.downloadLink(`estimate_${params.recordId}.pdf`, res.url, targetBlank)
          return res
				})
		},
		estimatePartsPDF: async (params = {}, targetBlank = true) => {
			let path = routesUtils.getApiPath(API.PDF_ESTIMATE_PARTS, { recordId: params.recordId })
			const offset = new Date().getTimezoneOffset() * -1
			path += `?offset=${offset}`
			return httpClient.get(path)
				.then((res) => {
          common.downloadLink(`estimate_${params.recordId}.pdf`, res.url, targetBlank)
          return res
				})
		},
		workorderPDF: async (params = {}, targetBlank = true) => {
			return fetchWorkorderPDF(params)
				.then((res) => {
          common.downloadLink(`workorder_${params.recordId}.pdf`, res.url, targetBlank)
          return res
				})
		},
		// Legacy estimateADASPDF removed - F-30833
		// estimateADASPDF: async (params = {}, targetBlank = true) => {
		// 	const path = routesUtils.getApiPath(API.PDF_ESTIMATE_ADAS, params)
		// 	return httpClient.get(path)
		// 		.then((res) => {
		// 			common.downloadLink(`estimate_${params.recordId}.pdf`, res.url, targetBlank)
		// 			return res
		// 		})
		// },
	}
}

export default pdfService
